module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_c('div', {
    staticClass: "nodata flex justify-center align-center flex-direction"
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": require("../assets/images/empty.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.text) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae5f7e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nomore.vue
// module id = 780
// module chunks = 20